import '@/styles/globals.css'
import '@/styles/rich-text.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Bricolage_Grotesque, Figtree, Geist_Mono } from 'next/font/google'
import { CartProvider } from '@/components/shop/cart-provider'
import CartDrawer from '@/components/shop/cart-drawer'

const sans = Figtree({
    subsets: ['latin']
})

const heading = Bricolage_Grotesque({
    subsets: ['latin']
})

const mono = Geist_Mono({
    subsets: ['latin']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <CartProvider>
            <div className='h-full font-sans'>
                <Head>
                    <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                    <meta name='viewport' content='width=device-width, initial-scale=1' />
                    <meta name='theme-color' content='#0a242b' />
                </Head>

                <Component {...pageProps} />

                <CartDrawer />
            </div>
        </CartProvider>
    )
}

export default App
